import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/baoqian.png';
const _withScopeId = n => (_pushScopeId("data-v-29b9471a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "popup"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "srv-time-selector"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bar bar-1"
}, [/*#__PURE__*/_createElementVNode("h1", null, "选择服务时间")], -1));
const _hoisted_5 = {
  key: 0,
  class: "load"
};
const _hoisted_6 = {
  key: 1,
  class: "bd"
};
const _hoisted_7 = {
  key: 0,
  class: "jiadian_data_wrap"
};
const _hoisted_8 = {
  key: 0,
  class: "chose-time"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = {
  class: "not-can-use"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "不可预约", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_14 = {
  style: {
    "font-size": "12px",
    "color": "#999"
  }
};
const _hoisted_15 = {
  class: "hours"
};
const _hoisted_16 = {
  key: 0,
  class: "chose-time"
};
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  key: 1
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  key: 1
};
const _hoisted_24 = {
  key: 0
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
  key: 1
};
const _hoisted_28 = ["onClick"];
const _hoisted_29 = {
  key: 1,
  class: "tips"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
import { ref, getCurrentInstance } from "vue";
import commonMethod from "../common/common.ts";
export default /*#__PURE__*/_defineComponent({
  __name: 'date',
  props: {
    isjiadian: {
      default: false,
      type: Boolean
    },
    channel: {
      default: 'h5',
      type: String
    }
  },
  emits: ['chooseDate'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const {
      proxy
    } = getCurrentInstance();
    const props = __props;
    const st_id = ref(0);
    const sa_id = ref(0);
    const s_id = ref(0);
    const soi_id = ref(0);
    const show = ref(true);
    const changeDate = ref('');
    const startTime = ref('');
    const endTime = ref('');
    const dateLists = ref([]);
    const getValuableDate = (order, saId, phone) => {
      st_id.value = order.st_id;
      s_id.value = order.s_id;
      soi_id.value = order.soi_id;
      sa_id.value = saId;
      proxy.$api.post(`${proxy.$url}ServiceDate/getRili`, {
        rs_appid: order.rs_appid,
        st_id: st_id.value,
        sa_id: saId,
        s_id: s_id.value,
        soi_id: soi_id.value,
        phone
      }).then(res => {
        dateLists.value = res.lists;
        if (res.lists) {
          show.value = false;
        }
      }).catch(err => {});
    };
    // 暴露方法
    __expose({
      getValuableDate
    });
    // 选择日期切换
    const dateChoose = () => {
      changeDate.value = '';
      startTime.value = '';
      endTime.value = '';
    };
    // 选择时间点
    const timeChoose = (date, hour) => {
      if (st_id.value == 1) {
        //家电-无具体时间：
        let times = ['09:30', '10:30', '11:00', '13:30', '14:30', '15:30', '16:30'];
        let i = Math.floor(Math.random() * (times.length - 1));
        if (i + 1 >= times.length) i = times.length - 2;
        startTime.value = date + ' ' + times[i];
        endTime.value = date + ' ' + times[i + 1];
      } else {
        let value = hour;
        if (hour == "上午") {
          value = "08:00";
        } else if (hour == "下午") {
          value = "13:00";
        }
        startTime.value = date + ' ' + value;
        endTime.value = 0;
      }
      if (changeDate.value == date + ' ' + hour) {
        changeDate.value = '';
      } else {
        changeDate.value = date + ' ' + hour;
      }
    };
    // 确定按钮
    const emit = __emit;
    const submitFunc = () => {
      if (!changeDate.value) {
        commonMethod.notify('warning', '时间选择不正确');
        return;
      }
      emit('chooseDate', changeDate.value, startTime.value, endTime.value);
    };
    return (_ctx, _cache) => {
      const _component_van_loading = _resolveComponent("van-loading");
      const _component_van_tab = _resolveComponent("van-tab");
      const _component_van_tabs = _resolveComponent("van-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("section", _hoisted_3, [_hoisted_4, show.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_van_loading, {
        size: "24px",
        vertical: ""
      }, {
        default: _withCtx(() => [_createTextVNode("时间获取中...")]),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [__props.isjiadian ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dateLists.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "hours",
          key: item.date
        }, [item.isReserve ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("button", {
          class: _normalizeClass([{
            'not-can-use': item.isFull
          }, {
            chose: changeDate.value == item.date + ' '
          }]),
          onClick: $event => timeChoose(item.date, '')
        }, [_createTextVNode(_toDisplayString(item.date) + " ", 1), _createElementVNode("div", null, _toDisplayString(item.week), 1), _createElementVNode("div", {
          style: _normalizeStyle({
            color: item.isFull ? '' : '#b50029'
          })
        }, _toDisplayString(item.isFull ? '已满' : '空闲'), 5)], 10, _hoisted_9)])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("button", _hoisted_11, [_createTextVNode(_toDisplayString(item.date) + " ", 1), _createElementVNode("div", null, _toDisplayString(item.week), 1), _hoisted_12])]))]);
      }), 128))])) : (_openBlock(), _createBlock(_component_van_tabs, {
        key: 1
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dateLists.value, (item, index) => {
          return _openBlock(), _createBlock(_component_van_tab, {
            key: item.date
          }, {
            title: _withCtx(() => [_createElementVNode("div", {
              style: {
                "text-align": "center"
              },
              onClick: dateChoose
            }, [_createElementVNode("span", null, _toDisplayString(item.date), 1), _hoisted_13, _createElementVNode("span", _hoisted_14, _toDisplayString(item.week), 1)])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [item.isReserve && !item.isFull ? (_openBlock(), _createElementBlock("div", _hoisted_16, [__props.channel === 'h5' ? (_openBlock(), _createElementBlock("div", _hoisted_17, [st_id.value == 3 || s_id.value == 58 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("button", {
              class: _normalizeClass([{
                'not-can-use': item.isAmFull
              }, {
                chose: changeDate.value == item.date + ' ' + '上午'
              }]),
              onClick: $event => timeChoose(item.date, '上午')
            }, [_createTextVNode(" 上午 "), _createElementVNode("div", {
              style: _normalizeStyle({
                color: item.isAmFull ? '' : '#b50029'
              })
            }, _toDisplayString(item.isAmFull ? '已满' : '空闲'), 5)], 10, _hoisted_19), _createElementVNode("button", {
              class: _normalizeClass([{
                'not-can-use': item.isPmFull
              }, {
                chose: changeDate.value == item.date + ' ' + '下午'
              }]),
              onClick: $event => timeChoose(item.date, '下午')
            }, [_createTextVNode(" 下午 "), _createElementVNode("div", {
              style: _normalizeStyle({
                color: item.isPmFull ? '' : '#b50029'
              })
            }, _toDisplayString(item.isPmFull ? '已满' : '空闲'), 5)], 10, _hoisted_20)])) : (_openBlock(), _createElementBlock("div", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.hours, hour => {
              return _openBlock(), _createElementBlock("button", {
                class: _normalizeClass([{
                  'not-can-use': hour.isFull
                }, {
                  chose: changeDate.value == item.date + ' ' + hour.hour
                }]),
                key: hour.hour,
                onClick: $event => timeChoose(item.date, hour.hour)
              }, [_createTextVNode(_toDisplayString(hour.hour) + " ", 1), _createElementVNode("div", {
                style: _normalizeStyle({
                  color: hour.isFull ? '' : '#b50029'
                })
              }, _toDisplayString(hour.isFull ? '已满' : '空闲'), 5)], 10, _hoisted_22);
            }), 128))]))])) : (_openBlock(), _createElementBlock("div", _hoisted_23, [st_id.value == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("button", {
              class: _normalizeClass([{
                'not-can-use': item.isAmFull
              }, {
                chose: changeDate.value == item.date + ' ' + '上午'
              }]),
              onClick: $event => timeChoose(item.date, '上午')
            }, [_createTextVNode(" 上午 "), _createElementVNode("div", {
              style: _normalizeStyle({
                color: item.isAmFull ? '' : '#b50029'
              })
            }, _toDisplayString(item.isAmFull ? '已满' : '空闲'), 5)], 10, _hoisted_25), _createElementVNode("button", {
              class: _normalizeClass([{
                'not-can-use': item.isPmFull
              }, {
                chose: changeDate.value == item.date + ' ' + '下午'
              }]),
              onClick: $event => timeChoose(item.date, '下午')
            }, [_createTextVNode(" 下午 "), _createElementVNode("div", {
              style: _normalizeStyle({
                color: item.isPmFull ? '' : '#b50029'
              })
            }, _toDisplayString(item.isPmFull ? '已满' : '空闲'), 5)], 10, _hoisted_26)])) : (_openBlock(), _createElementBlock("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.hours, hour => {
              return _openBlock(), _createElementBlock("button", {
                class: _normalizeClass([{
                  'not-can-use': hour.isFull
                }, {
                  chose: changeDate.value == item.date + ' ' + hour.hour
                }]),
                key: hour.hour,
                onClick: $event => timeChoose(item.date, hour.hour)
              }, [_createTextVNode(_toDisplayString(hour.hour) + " ", 1), _createElementVNode("div", {
                style: _normalizeStyle({
                  color: hour.isFull ? '' : '#b50029'
                })
              }, _toDisplayString(hour.isFull ? '已满' : '空闲'), 5)], 10, _hoisted_28);
            }), 128))]))]))])) : (_openBlock(), _createElementBlock("div", _hoisted_29, [_hoisted_30, _createElementVNode("p", null, _toDisplayString(!item.isReserve ? '抱歉，今天的服务暂时不能预约哦~' : '抱歉，今天的服务已约满~'), 1)]))])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })), _createElementVNode("div", {
        class: "out"
      }, [_createElementVNode("button", {
        class: "submit",
        onClick: submitFunc
      }, "确定")])]))])])]);
    };
  }
});